module.exports = __webpack_public_path__ + "img/portfolio.9a06dd5f.svg";